import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/**
 * Capture a DOM node visually and download as a multi-page PDF (A4).
 * Matches on-screen look via html2canvas.
 */
export async function exportElementToPdf(element, {
  fileName = 'tenanthub-report.pdf',
  marginMm = 8,
  scale = Math.min(2, window.devicePixelRatio || 1.5)
} = {}) {
  if (!element) {
    throw new Error('Nothing to export');
  }

  const canvas = await html2canvas(element, {
    scale,
    useCORS: true,
    allowTaint: true,
    backgroundColor: '#ffffff',
    logging: false,
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight
  });

  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const usableWidth = pageWidth - marginMm * 2;
  const usableHeight = pageHeight - marginMm * 2;

  const imgWidth = usableWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = marginMm;

  pdf.addImage(imgData, 'PNG', marginMm, position, imgWidth, imgHeight, undefined, 'FAST');
  heightLeft -= usableHeight;

  while (heightLeft > 1) {
    position = marginMm - (imgHeight - heightLeft);
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', marginMm, position, imgWidth, imgHeight, undefined, 'FAST');
    heightLeft -= usableHeight;
  }

  pdf.save(fileName);
  return fileName;
}
